import {useMutation, useQueryClient} from '@tanstack/react-query';

import {invalidateAllTrustAccountTeams} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useApiClient} from '@/hooks';

import {teamApi} from '../api';
import {teamKeys} from './useTeamMembersQuery';

import type {ChangeMemberRolePayload} from '@sollapay/types';

export function useChangeMemberRoleMutation() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: {memberId: string; payload: ChangeMemberRolePayload}) =>
      teamApi.changeMemberRole(client, params.memberId, params.payload),
    onSuccess: () => {
      // Both the old and new role's `memberCount` shift.
      queryClient.invalidateQueries({queryKey: teamKeys.members()});
      queryClient.invalidateQueries({queryKey: teamKeys.roles()});
      invalidateAllTrustAccountTeams(queryClient);
    }
  });
}
